import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';



import { PessoalService } from '../../../../providers/pessoal-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';
import { RolresponsaveisService } from '../../../../providers/rolresponsaveis-service';

import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { CargoService } from "../../../../providers/cargo-service";

declare var jsPDF: any;

@Component({
  selector: 'page-dem-quadro-pessoal',
  templateUrl: 'dem-quadro-pessoal.html',
  providers: [
    PessoalService
  ]
})
export class PessoalDemQuadroPessoallPage extends ModulosController {
  listaDados: any = [];
  listaDadosVinculo: any = [];
  listaCargo: any = [];
  listaTiposVinculos: any = [];
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "111";
  tiposArquivosAceitos: string = "application/xls";
  dadosImportados: any[];
  finalExercicio: any = 0;
  finalExercicioOcupados: any = 0;
  finalExercicioVagos: any = 0;

  inicioExercicio: any = 0;
  criadosExercicio: any = 0;
  extintosExercicio: any = 0;
  ocupadosInicioExercicio: any = 0;
  nomeadosExercicio: any = 0;
  cargosExoneradosExercicio: any = 0;

  dataMask = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

  page1: number = 1;
  page2: number = 1;

  numberMask = createNumberMask({
    prefix: '',
    suffix: '', // This will put the dollar sign at the end, with a space.
    thousandsSeparatorSymbol: '.',
    allowDecimal: false,
    decimalSymbol: ','
  });

  vinculoParaAdicionar: any = {
    inicioExercicio: '',
    criadosExercicio: '',
    extintosExercicio: '',
    finalExercicio: '',
    ocupadosInicioExercicio: '',
    nomeadosExercicio: '',
    cargosExoneradosExercicio: '',
    ocupadosfinalExercicio: '',
    cargosVagosFinalExercicio: '',
    nomeCargo: '',
    dsGrupoCargo: ''
  }

  flTipo: any = "cargo";
  listaDadosVinculos: any;

  objetoEdit: any = null;
  listEdit: any = [];
  analise: any = null;

  @ViewChild('inputFileCM')
  inputFileCMVar: ElementRef;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public CargoService: CargoService,
    public navParams: NavParams,
    public pessoalService: PessoalService,
    private fileService: FileService,
    public gestaoPcaService: GestaoPcaService,
    public rolService: RolresponsaveisService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.analise = this.navParams.get('analise');

    this.carregarDados();
    this.setModuloId(11);
  }

  carregarDados() {
    this.pessoalService.listarDemonstrativoQuadroPessoal().subscribe(data => {
      this.listaDados = data;

      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });

    this.pessoalService.listarGrupoCargo().subscribe(data => {
      this.listaTiposVinculos = data;
    }, error => {
      console.log("erro: " + error);
    });

    this.CargoService.listarCargoAtivo(11).subscribe(data => {
      this.listaCargo = data;
    }, error => console.log("erro: " + error));

  }

  calcularFinalExercicio() {

    if (this.vinculoParaAdicionar.inicioExercicio == "" || this.vinculoParaAdicionar.inicioExercicio == null || this.vinculoParaAdicionar.inicioExercicio == undefined) {
      this.inicioExercicio = 0;
    } else {
      this.inicioExercicio = this.vinculoParaAdicionar.inicioExercicio.toString().replace(/\./g, '');
    }

    if (this.vinculoParaAdicionar.criadosExercicio == "" || this.vinculoParaAdicionar.criadosExercicio == null || this.vinculoParaAdicionar.criadosExercicio == undefined) {
      this.criadosExercicio = 0;
    } else {
      this.criadosExercicio = this.vinculoParaAdicionar.criadosExercicio.toString().replace(/\./g, '');
    }

    if (this.vinculoParaAdicionar.extintosExercicio == "" || this.vinculoParaAdicionar.extintosExercicio == null || this.vinculoParaAdicionar.extintosExercicio == undefined) {
      this.extintosExercicio = 0;
    } else {
      this.extintosExercicio = this.vinculoParaAdicionar.extintosExercicio.toString().replace(/\./g, '');
    }

    this.finalExercicio = parseInt(this.inicioExercicio) + parseInt(this.criadosExercicio) - parseInt(this.extintosExercicio);
    this.vinculoParaAdicionar.finalExercicio = this.finalExercicio;

    //return this.finalExercicio;

    this.calcularFinalExercicioVagos();
  }

  calcularFinalExercicioOcupados() {

    if (this.vinculoParaAdicionar.ocupadosInicioExercicio == "" || this.vinculoParaAdicionar.ocupadosInicioExercicio == null || this.vinculoParaAdicionar.ocupadosInicioExercicio == undefined) {
      this.ocupadosInicioExercicio = 0;
    } else {
      this.ocupadosInicioExercicio = this.vinculoParaAdicionar.ocupadosInicioExercicio.toString().replace(/\./g, '');
    }

    if (this.vinculoParaAdicionar.nomeadosExercicio == "" || this.vinculoParaAdicionar.nomeadosExercicio == null || this.vinculoParaAdicionar.nomeadosExercicio == undefined) {
      this.nomeadosExercicio = 0;
    } else {
      this.nomeadosExercicio = this.vinculoParaAdicionar.nomeadosExercicio.toString().replace(/\./g, '');
    }

    if (this.vinculoParaAdicionar.cargosExoneradosExercicio == "" || this.vinculoParaAdicionar.cargosExoneradosExercicio == null || this.vinculoParaAdicionar.cargosExoneradosExercicio == undefined) {
      this.cargosExoneradosExercicio = 0;
    } else {
      this.cargosExoneradosExercicio = this.vinculoParaAdicionar.cargosExoneradosExercicio.toString().replace(/\./g, '');
    }


    this.finalExercicioOcupados = parseInt(this.ocupadosInicioExercicio) + parseInt(this.nomeadosExercicio) - parseInt(this.cargosExoneradosExercicio);

    this.vinculoParaAdicionar.ocupadosfinalExercicio = this.finalExercicioOcupados;
    //return this.finalExercicioOcupados;

    this.calcularFinalExercicioVagos();
  }

  calcularFinalExercicioVagos() {

    //this.finalExercicioVagos = this.finalExercicio - this.finalExercicioOcupados;
    this.finalExercicioVagos = this.vinculoParaAdicionar.finalExercicio - this.vinculoParaAdicionar.ocupadosfinalExercicio;


    this.vinculoParaAdicionar.cargosVagosFinalExercicio = this.finalExercicioVagos;
    // return this.finalExercicioVagos;
  }

  fileChange(event) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", 
    callback => {
      if (callback) {
        this.loading = true; 
        this.fileService.cargaQuadroPessoal(event, this.idSecaoPagina).subscribe(
          data => {
            this.inputFileCMVar.nativeElement.value = "";

            this.dadosImportados = data;

            let cargosDuplicados = "";

            for (let j = 0; j < this.dadosImportados.length; j++) {            
              if (this.listaDados.findIndex(i => 
                  i.cargo.nomeCargo.trim() === this.dadosImportados[j].cargo.nomeCargo.trim()
                  && i.vinculo.dsGrupoCargo === this.dadosImportados[j].vinculo.dsGrupoCargo 
                  ) == -1) {
                this.listaDados.push(this.dadosImportados[j]);
              } else {
                cargosDuplicados += this.dadosImportados[j].vinculo.dsGrupoCargo  +" - "+ this.dadosImportados[j].cargo.nomeCargo + ", ";
              }
            }
            if(cargosDuplicados.length > 0) {
              this.alertService.mostraAlerta("Atenção", "Um ou mais registros foram desconsiderados na importação por serem considerados duplicados.<br/><br/>"
              + "Cargos desconsiderados: " 
              + cargosDuplicados.slice(0, - 2) + ".<br/><br/>"
              + "Para efetivar a importação dos demais registros, clique em salvar ou finalizar.");
            } else {
                this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");
            }
            this.loading = false;
          }, 
          error => {
            this.inputFileCMVar.nativeElement.value = "";
            this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error.mensagem);
            this.loading = false;          
          });
        } else {
          this.inputFileCMVar.nativeElement.value = "";
      }
    });
  }

  downloadDoModelo() {
    let idTemplate = 1;

    this.fileService.downloadModeloCargaPessoal(idTemplate);
  }

  adicionarVinculo() {

    if (this.vinculoParaAdicionar.criadosExercicio === '') {
      this.vinculoParaAdicionar.criadosExercicio = 0;
    }
    if (this.vinculoParaAdicionar.extintosExercicio === '') {
      this.vinculoParaAdicionar.extintosExercicio = 0;
    }

    if (this.vinculoParaAdicionar.nomeadosExercicio === '') {
      this.vinculoParaAdicionar.nomeadosExercicio = 0;
    }
    if (this.vinculoParaAdicionar.cargosExoneradosExercicio === '') {
      this.vinculoParaAdicionar.cargosExoneradosExercicio = 0;
    }

    if (this.vinculoParaAdicionar.inicioExercicio !== '' &&
      this.vinculoParaAdicionar.ocupadosInicioExercicio !== '' &&
      this.vinculoParaAdicionar.nomeCargo !== '' &&
      this.vinculoParaAdicionar.dsGrupoCargo !== '') {


      this.vinculoParaAdicionar.finalExercicio = this.finalExercicio;
      this.vinculoParaAdicionar.ocupadosfinalExercicio = this.finalExercicioOcupados;
      this.vinculoParaAdicionar.cargosVagosFinalExercicio = this.finalExercicioVagos;


      let vinculoNovo = {
        "idDemonstrativoQuadroPessoal": 0,
        "inicioExercicio": this.vinculoParaAdicionar.inicioExercicio.toString().replace(/\./g, ''),
        "criadosExercicio": this.vinculoParaAdicionar.criadosExercicio.toString().replace(/\./g, ''),
        "extintosExercicio": this.vinculoParaAdicionar.extintosExercicio.toString().replace(/\./g, ''),
        "finalExercicio": this.vinculoParaAdicionar.finalExercicio.toString().replace(/\./g, ''),
        "ocupadosInicioExercicio": this.vinculoParaAdicionar.ocupadosInicioExercicio.toString().replace(/\./g, ''),
        "nomeadosExercicio": this.vinculoParaAdicionar.nomeadosExercicio.toString().replace(/\./g, ''),
        "cargosExoneradosExercicio": this.vinculoParaAdicionar.cargosExoneradosExercicio.toString().replace(/\./g, ''),
        "ocupadosfinalExercicio": this.vinculoParaAdicionar.ocupadosfinalExercicio.toString().replace(/\./g, ''),
        "cargosVagosFinalExercicio": this.vinculoParaAdicionar.cargosVagosFinalExercicio.toString().replace(/\./g, ''),
        "idPca": this.gestaoPcaService.getPCA().id,
        "idModuloAnalise": this.idSecaoPagina,
        "cargo": {
          "idCargo": 0,
          "nomeCargo": this.vinculoParaAdicionar.nomeCargo
        },
        "vinculo": {
          "idGrupoCargo": 0,
          "dsGrupoCargo": this.vinculoParaAdicionar.dsGrupoCargo
        }
      };

      let vinculoNomeacaoTemp = this.listaTiposVinculos.filter((vinculoNomeacao) => this.vinculoParaAdicionar.dsGrupoCargo == vinculoNomeacao.dsGrupoCargo)[0];
      let vinculoTemp = this.listaCargo.filter((cargo) => this.vinculoParaAdicionar.nomeCargo == cargo.nomeCargo)[0];

      if (vinculoNomeacaoTemp != null) {
        vinculoNovo.vinculo.idGrupoCargo = vinculoNomeacaoTemp.idGrupoCargo;
      }

      if (vinculoTemp != null) {
        vinculoNovo.cargo.idCargo = vinculoTemp.idCargo;
      }

      if (this.listaDados.findIndex(i => i.cargo.nomeCargo === vinculoNovo.cargo.nomeCargo && i.vinculo.dsGrupoCargo === vinculoNovo.vinculo.dsGrupoCargo) != -1 && !this.objetoEdit) {
        this.alertService.mostraAlerta("", "Vínculo já adicionado!");
      } else {

        if (this.objetoEdit) {
          let index = this.listaDados.indexOf(this.objetoEdit);
          this.listaDados.splice(index, 1);

          this.listEdit.push(this.objetoEdit);
        }

        this.listaDados.push(vinculoNovo);

        this.objetoEdit = null;

        this.vinculoParaAdicionar.inicioExercicio =
          this.vinculoParaAdicionar.criadosExercicio =
          this.vinculoParaAdicionar.extintosExercicio =
          this.vinculoParaAdicionar.finalExercicio =
          this.vinculoParaAdicionar.ocupadosInicioExercicio =
          this.vinculoParaAdicionar.nomeadosExercicio =
          this.vinculoParaAdicionar.cargosExoneradosExercicio =
          this.vinculoParaAdicionar.ocupadosfinalExercicio =
          this.vinculoParaAdicionar.cargosVagosFinalExercicio =
          this.vinculoParaAdicionar.dsGrupoCargo =
          this.vinculoParaAdicionar.nomeCargo = '';
      }
    } else {
      this.alertService.mostraAlerta("", "Todos os campos são obrigatórios.");
    }
  }

  removerVinculo(vinculo, edit) {

    if (!edit) {
      this.alertService.mostraModalConfirmacao("Remover Vínculo", "Deseja remover o vínculo?", callback => {
        if (callback) {

          let index = this.listaDados.indexOf(vinculo);
          this.listaDados.splice(index, 1);

          if (vinculo.idDemonstrativoQuadroPessoal != 0) {
            this.deletarDemonstrativoQuadroPessoal(vinculo.idDemonstrativoQuadroPessoal);
          }
        }
      });
    } else {
      // let index = this.listaDados.indexOf(vinculo);
      // this.listaDados.splice(index, 1);

      if (vinculo.idDemonstrativoQuadroPessoal != 0) {
        this.deletarDemonstrativoQuadroPessoal(vinculo.idDemonstrativoQuadroPessoal);
      }
    }
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  voltarParaPessoal() {
    this.menuService.redirecionarPagina(this.pessoalService.obterIdPaginaPessoal());
  }

  salvar() {

    let tempVinculo = null;
    let tempCargo = null;
    let msgErro = '';
    let constPularLinhaHTML = "<br>";

    this.listEdit.forEach(item => {
      this.removerVinculo(item, true);
    });

    this.listEdit = [];

    for (let j = 0; j < this.listaDados.length; j++) {

      tempVinculo = this.listaTiposVinculos.filter((vinculo) => this.listaDados[j].vinculo.dsGrupoCargo.trim() == vinculo.dsGrupoCargo.trim())[0];
      if (!tempVinculo) {
        msgErro += '- Vínculo '+ this.listaDados[j].vinculo.dsGrupoCargo.trim() +' não encontrado. Necessário editar o item.' + constPularLinhaHTML;
      }

      tempCargo = this.listaCargo.filter((cargo) => this.listaDados[j].cargo.nomeCargo.trim() == cargo.nomeCargo.trim())[0];
      if (!tempCargo) {
        msgErro += '- Cargo '+ this.listaDados[j].cargo.nomeCargo.trim() +' não cadastrado ou inativo. Necessário editar o item.' + constPularLinhaHTML;
      }

      if (this.listaDados[j].cpf) {
        this.listaDados[j].cpf = this.listaDados[j].cpf.replace(/[^\w\s]/gi, '');
      }
    }

    if (msgErro == '') {
      this.pessoalService.salvarDemonstrativoQuadroPessoal(this.listaDados, this.idSecaoPagina).subscribe(data => {
        this.alertService.mostraAlerta("", "Salvo com sucesso.");
        this.carregarDados();
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
      });
    } else {
      this.alertService.mostraAlerta("Ocorreu um erro ao salvar", msgErro);
    }
  }

  deletarDemonstrativoQuadroPessoal(idDemonstrativoQuadroPessoal) {
    this.pessoalService.deletarDemonstrativoQuadroPessoal(idDemonstrativoQuadroPessoal).subscribe(data => {

    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir:" + error);
    })
  }

  finalizar() {
    let idAnalise = "";

    let tempVinculo = null;
    let tempCargo = null;
    let msgErro = '';
    let constPularLinhaHTML = "<br>";

    this.listEdit.forEach(item => {
      this.removerVinculo(item, true);
    });

    this.listEdit = [];

    for (let j = 0; j < this.listaDados.length; j++) {

      tempVinculo = this.listaTiposVinculos.filter((vinculo) => this.listaDados[j].vinculo.dsGrupoCargo.trim() == vinculo.dsGrupoCargo.trim())[0];
      if (!tempVinculo) {
        msgErro += '- Vínculo '+ this.listaDados[j].vinculo.dsGrupoCargo.trim() +' não encontrado. Necessário editar o item.' + constPularLinhaHTML;
      }

      tempCargo = this.listaCargo.filter((cargo) => this.listaDados[j].cargo.nomeCargo.trim() == cargo.nomeCargo.trim())[0];
      if (!tempCargo) {
        msgErro += '- Cargo '+ this.listaDados[j].cargo.nomeCargo.trim() +' não cadastrado ou inativo. Necessário editar o item.' + constPularLinhaHTML;
      }

      if (this.listaDados[j].cpf) {
        this.listaDados[j].cpf = this.listaDados[j].cpf.replace(/[^\w\s]/gi, '');
      }
    }

    if (msgErro == '') {
      if (this.listaDados) {
        this.pessoalService.finalizarDemonstrativoQuadroPessoal(this.listaDados, this.idSecaoPagina).subscribe(data => {
          this.alertService.mostraAlerta("", "Finalizado com sucesso.");
          this.voltarParaPessoal();
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
        });
      } else {
        this.alertService.mostraAlerta("Ocorreu um erro ao finalizar", msgErro);
      }
    } else {
      this.alertService.mostraAlerta("Ocorreu um erro ao finalizar", msgErro);
    }
  }

  editar(item) {
    this.vinculoParaAdicionar.inicioExercicio = item.inicioExercicio;
    this.vinculoParaAdicionar.criadosExercicio = item.criadosExercicio;
    this.vinculoParaAdicionar.extintosExercicio = item.extintosExercicio;
    this.vinculoParaAdicionar.finalExercicio = item.finalExercicio;
    this.vinculoParaAdicionar.ocupadosInicioExercicio = item.ocupadosInicioExercicio;
    this.vinculoParaAdicionar.nomeadosExercicio = item.nomeadosExercicio;
    this.vinculoParaAdicionar.cargosExoneradosExercicio = item.cargosExoneradosExercicio;
    this.vinculoParaAdicionar.ocupadosfinalExercicio = item.ocupadosfinalExercicio;
    this.vinculoParaAdicionar.cargosVagosFinalExercicio = item.cargosVagosFinalExercicio;
    this.vinculoParaAdicionar.dsGrupoCargo = item.vinculo.dsGrupoCargo;
    this.vinculoParaAdicionar.nomeCargo = item.cargo.nomeCargo;

    this.objetoEdit = item;
  }

  printData() {

    var doc = new jsPDF("l");
    var totalPagesExp = "{total_pages_count_string}";

    var pageContent = function (data) {
      // HEADER
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.setFontStyle('normal');

      doc.text("Pessoal - Quantitativo do Quadro de Pessoal", data.settings.margin.left + 15, 22);

      // FOOTER
      var str = "Page " + data.pageCount;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    };

    var columns = [
      { title: "Vínculo", dataKey: "vinculo" },
      { title: "Cargo/Posto de Trabalho", dataKey: "cargo" },
      { title: "Qtde. Início Exercício", dataKey: "qtdInicio" },
      { title: "Qtde. Criados Exercício", dataKey: "qtdCriados" },
      { title: "Qtde. Extintos Exercício", dataKey: "qtdExtintos" },
      { title: "Qtde. Final Exercício", dataKey: "qtdFinal" },
      { title: "Ocup. Início Exercício", dataKey: "ocupInicio" },
      { title: "Ocup. Nomeados Exercício", dataKey: "ocupNomeados" },
      { title: "Ocup. Exonerados Exercício", dataKey: "ocupExonerados" },
      { title: "Ocup. Final Exercício", dataKey: "ocupFinal" },
      { title: "Vagos Final Exercício", dataKey: "vagos" }
    ];

    let rows = [];

    this.listaDados.forEach(element => {

      var item = {
        "vinculo": element.vinculo.dsGrupoCargo != null ? element.vinculo.dsGrupoCargo : "",
        "cargo": element.cargo.nomeCargo != null ? element.cargo.nomeCargo : "",
        "qtdInicio": element.inicioExercicio != null ? element.inicioExercicio : "",
        "qtdCriados": element.criadosExercicio != null ? element.criadosExercicio : "",
        "qtdExtintos": element.extintosExercicio != null ? element.extintosExercicio : "",
        "qtdFinal": element.finalExercicio != null ? element.finalExercicio : "",
        "ocupInicio": element.ocupadosInicioExercicio != null ? element.ocupadosInicioExercicio : "",
        "ocupNomeados": element.nomeadosExercicio != null ? element.nomeadosExercicio : "",
        "ocupExonerados": element.cargosExoneradosExercicio != null ? element.cargosExoneradosExercicio : "",
        "ocupFinal": element.ocupadosfinalExercicio != null ? element.ocupadosfinalExercicio : "",
        "vagos": element.cargosVagosFinalExercicio != null ? element.cargosVagosFinalExercicio : ""
      };

      rows.push(item);
    });

    doc.autoTable(columns, rows, {
      //   theme: 'grid',
      //   addPageContent: pageContent,
      //   margin: { top: 30 },
      //   styles: {
      //       overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
      //       columnWidth: 'auto'
      //   }
      // });

      theme: 'grid',
      addPageContent: pageContent,
      margin: {
        top: 30,
        left: 5
      },
      styles: {
        overflow: 'linebreak',
        columnWidth: 'auto',
        fontSize: 7
      },
      columnStyles: {
        text: { columnWidth: 'auto' }
      }
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('pessoal_qtd_quadro_pessoal.pdf');
  }

  somarInicioExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.inicioExercicio;
    });

    return val;
  }

  somarCriadosExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.criadosExercicio;
    });

    return val;
  }

  somarExtintosExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.extintosExercicio;
    });

    return val;
  }

  somarFinalExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.finalExercicio;
    });

    return val;
  }

  somarOcupadosInicioExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.ocupadosInicioExercicio;
    });

    return val;
  }

  somarNomeadosExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.nomeadosExercicio;
    });

    return val;
  }

  somarCargosExoneradosExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.cargosExoneradosExercicio;
    });

    return val;
  }

  somarOcupadosfinalExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.ocupadosfinalExercicio;
    });

    return val;
  }

  somarCargosVagosFinalExercicio(item) {
    let val = 0;

    item[1].forEach(element => {
      val += +element.cargosVagosFinalExercicio;
    });

    return val;
  }

  colocarComoTitulo(text) {
    var ignore = ['de', 'da', 'das', 'do', 'dos'];
    var words = text.toLowerCase().split(" ");
    for (var a = 0; a < words.length; a++) {
      var w = words[a];
      if (w.length>2) {

        words[a] = w[0].toUpperCase() + w.slice(1);
      }
    }
    return words.join(" ");

  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/pessoal/dem-quadro-pessoal/dem-quadro-pessoal.ts